import React, { useState, useEffect, memo } from "react";
import { ServerConfig } from "config";
import axios from "axios";
import { useSelector } from "react-redux";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import PaginatedList from "../../components/PaginatedList/PaginatedList";
import FileUpload from "../PublicRelations/FileUpload.js";

import _, { get } from "lodash";

const evt = new Event("customertable_is_dirty");

const useStyles = makeStyles((theme) => ({
  formGroup: { margin: "10px 0" },
  formControl: { width: "256px" },
  fieldLabel: { display: "block", width: "150px" },
}));

const BagStickerMap = () => {
  const classes = useStyles();
  const auth = useSelector((state) => state.auth);
  const editable_fields = [];

  const [tenants, setTenants] = useState([]);
  const [selectedTenant, setSelectedTenant] = useState("");

  useEffect(() => {
    const fetchTenants = async () => {
      const config = { headers: { "Content-Type": "application/json" } };
      if (auth.access_token)
        config.headers.Authorization = `Bearer ${auth.access_token}`;

      const results = await axios.get(
        `${ServerConfig.SERVER_URL}/admin/tenants`,
        config,
      );
      setTenants(results.data || []);
    };

    fetchTenants();
  }, []);

  const view_fields = [
    ["", "Customer", "header"],
    ["trackingcode.customer_id", "Customer ID"],
    ["trackingcode.customer.first_name", "Customer First Name"],
    ["trackingcode.customer.last_name", "Customer Last Name"],
    ["trackingcode.customer.email", "Customer Email"],
    ["trackingcode.customer.phone_number", "Customer Phone"],
    ["", "Ecosack", "break"],
    ["bagcode", "Bag Code"],
    ["stickercode", "Sticker Code"],
    ["trackingcode.state", "Current State", "ecosackState"],
    ["trackingcode.created", "Created", "timestamp"],
    ["trackingcode.lifecycle.at_user", "Assigned To Customer", "timestamp"],
    [
      "trackingcode.lifecycle.picked_up",
      "Received At Tenant Site",
      "timestamp",
    ],
    ["id_tenant", "Assigning Tenant ID"],
    ["tenant.business_name", "Assigning Tenant Name"],
    ["trackingcode.id_tenant_receiving", "Receiving Tenant ID"],
    ["trackingcode.name_tenant_receiving", "Receiving Tenant Name"],
    ["trackingcode.lifecycle.picked_up", "Received", "hours_ago"],
    ["trackingcode.lifecycle.processed", "Processed by Tenant", "timestamp"],
    ["trackingcode.last_updated", "Last Updated", "timestamp"],
  ];

  return (
    <>
      {/* Tenant selector */}
      <div className={`form-group ${classes.formGroup}`}>
        <label className={classes.fieldLabel}>Tenant</label>
        <select
          className={`form-control ${classes.formControl}`}
          value={selectedTenant}
          onChange={(e) => setSelectedTenant(e.target.value)}
        >
          <option value="">Please Select</option>
          {_.map(tenants, (opt) => (
            <option key={opt.id} value={opt.id}>
              {opt.business_name}
            </option>
          ))}
        </select>
      </div>
      <FileUpload
        uploadUrl="/trackingcode/bagpacksandstickers/upload"
        currentUrl=""
        onChangeCallback={(location) => {
          window.dispatchEvent(evt);
        }}
        token={auth.access_token}
        accept_types=".csv"
        checkCsvDuplicates={true}
        extraFormData={{
          id_tenant: selectedTenant,
        }}
      />
      {/* /bagpacksandstickers/upload */}
      <PaginatedList
        list_get_url={`${ServerConfig.SERVER_URL}/trackingcode/bagpacksandstickers/`}
        view_request={(row) =>
          `${ServerConfig.SERVER_URL}/trackingcode/bagpacksandstickers/detail/${row.bagcode}`
        }
        column_names={["bagcode", "stickercode", "id_tenant", "name_tenant"]}
        header_names={["Bag Code", "Sticker Code", "Tenant ID", "Tenant Name"]}
        view_fields={view_fields}
        editable_fields={editable_fields}
      />
    </>
  );
};

export default BagStickerMap;
